<p-table
  #userTable
  [globalFilterFields]="['username', 'firstName', 'lastName']"
  [loading]="loading"
  *ngIf="users"
  [value]="users">
  <ng-template pTemplate="caption">
    <app-table-list-caption
      [addRoute]="addRoute"
      [searchWord]="searchWord"
      (clearTable)="clear(userTable)"
      (search)="
        userTable.filterGlobal($event, 'contains')
      "></app-table-list-caption>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th class="w-2rem"></th>
      <th>Anmeldename</th>
      <th>Vorname</th>
      <th>Nachname</th>
      <th>Zugriffsrechte</th>
      <th>Aktionen</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr>
      <td class="text-color-secondary">
        <i [class]="user.locked ? 'fas fa-lock' : 'fas fa-check-circle'"></i>
      </td>
      <td>{{ user.username }}</td>
      <td>{{ user.firstName }}</td>
      <td>{{ user.lastName }}</td>
      <td>
        @if (user.level > 0 && getUserLevel(user.level); as level) {
          <p-tag severity="secondary">
            <span class="flex gap-2 align-items-center">
              <i [class]="level.icon"></i> {{ level.label }}
            </span>
          </p-tag>
        } @else {
          <p class="flex gap-2">
            <p-tag
              [severity]="getWorkspaceCount(user) > 0 ? undefined : 'secondary'"
              [pTooltip]="getWorkspaceTooltip(user)"
              tooltipPosition="top"
              class="cursor-pointer">
              <span class="flex align-items-center gap-2">
                <i class="fas fa-users-viewfinder mr-1"></i>
                {{ getWorkspaceCount(user) }}
              </span>
            </p-tag>
            <p-tag
              [severity]="getRoleCount(user) > 0 ? undefined : 'secondary'"
              [pTooltip]="getRoleTooltip(user)"
              tooltipPosition="top"
              class="cursor-pointer">
              <span class="flex align-items-center gap-2">
                <i class="fas fa-user-shield mr-1"></i>{{ getRoleCount(user) }}
              </span>
            </p-tag>
          </p>
        }
      </td>
      <td>
        <a
          pButton
          class="p-button-rounded p-button-xs p-button-primary mr-2"
          pTooltip="Nutzer:in wechseln"
          tooltipPosition="left"
          icon="fas fa-people-arrows"
          (click)="switchUser(user._id)"></a>
        <p-button
          [disabled]="!user.firstLogin || user.locked"
          [rounded]="true"
          styleClass="p-button-xs mr-2"
          pTooltip="E-Mail erneut senden"
          tooltipPosition="left"
          icon="fas fa-paper-plane"
          (click)="resendUserMail(user)"></p-button>
        @if (communeId) {
          <a
            pButton
            class="p-button-rounded p-button-xs p-button-primary mr-2"
            [icon]="'fas fa-pen'"
            [routerLink]="[
              { outlets: { bearbeiten: [communeId, 'user', user._id] } },
            ]"></a>
          <app-table-list-actions
            [item]="user"
            [hideEdit]="true"
            (confirm)="confirm($event, user, user.username)">
          </app-table-list-actions>
        } @else {
          <app-table-list-actions
            [item]="user"
            (confirm)="confirm($event, user, user.username)">
          </app-table-list-actions>
        }
      </td>
    </tr>
  </ng-template>
</p-table>

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-10'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay"></app-mask>

<div
  *ngIf="!store.asArray().length"
  role="alert"
  class="p-message p-message-info">
  <div class="p-message-wrapper">
    <span class="p-message-summary">Keine Nutzer:innen gefunden</span>
  </div>
</div>
